import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import { preload } from 'swr';

import MeetingAttendees from './meetingAttendees';
import MeetingInfo from './meetingInfo';
import MeetingNotesTab from './meetingNotesTab';

import { ROLE_VALUES } from '../../../constants/customerConstant';
import { useAuth } from '../../../contexts/auth/authContext';
import {
  MeetingSidebar as MeetingSidebarEnum,
  useMeetingContext,
} from '../../../contexts/meeting/meetingContext';
import meetingService, {
  getMeetingNotesURL,
} from '../../../services/meetingService';

function MeetingSidebar() {
  const { openSidebar, setOpenSidebar } = useMeetingContext();
  const { meetingDetails } = useMeetingContext();
  const { userType } = useAuth();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code');
  const name = queryParams.get('name');

  if (userType !== ROLE_VALUES.WHISTLE_BLOWER) {
    const meetingID = meetingDetails.current?.meeting_id.toString() ?? '';
    preload(getMeetingNotesURL(meetingID), () => {
      return meetingService.getMeetingNotes(meetingID);
    });
  }

  const isGuest = code && name;

  return (
    <Box
      sx={{
        display: openSidebar ? 'block' : 'none',
        flex: 1,

        padding: {
          xs: '16px',
          md: '16px 16px 16px 0px',
        },
        width: {
          xs: '100vw',
          md: '40vw',
          lg: '25vw',
        },
        maxHeight: '100vh',
      }}
    >
      <Box
        sx={{
          height: '100%',
          borderRadius: '6px',
          background: (theme) => theme.palette.neutralBlackBg[50],
          padding: '20px 12px 12px 12px',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            display: {
              xs: 'block',
              md: 'none',
            },
            position: 'absolute',
            top: ' 8px',
            right: '8px',
          }}
        >
          <IconButton
            onClick={() => {
              setOpenSidebar(null);
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {openSidebar === MeetingSidebarEnum.INFO && <MeetingInfo />}
        {openSidebar === MeetingSidebarEnum.ATTENDEES && <MeetingAttendees />}
        {userType !== ROLE_VALUES.WHISTLE_BLOWER &&
          !isGuest &&
          openSidebar === MeetingSidebarEnum.NOTES && <MeetingNotesTab />}
      </Box>
    </Box>
  );
}

export default MeetingSidebar;
